import React from 'react';
import Grid from '@powerednow/components/Grid/Grid';
import Box from '@powerednow/components/Box/Box';
import LabelValuePair from '@powerednow/components/LabelValuePair/LabelValuePair';
import Paper from '@powerednow/components/Paper/Paper';
import textUtils from '@powerednow/shared/modules/utilities/textUtils';
import { styled } from '@mui/material/styles';

const PurchaseOrderCardPaper = styled(Paper, {
    name: 'PurchaseOrderCardPaper',
    slot: 'root',
})(({ theme, onClick }) => ({
    boxShadow: `0 3px 0px ${theme.palette.appSpecificColors?.silverBase}`,
    borderRadius: '5px',
    backgroundColor: '#ecf0f1',
    border: `1px solid ${theme.palette.appSpecificColors?.silverBase}`,
    '&:hover': {
        backgroundColor: '#dde4e6',
    },
    cursor: onClick ? 'pointer' : undefined,
}));
function PurchaseOrderCard({ purchaseOrder, onClick }) {
    return (
        <PurchaseOrderCardPaper onClick={onClick}>
            <Grid container>
                <Grid item xs={12} sm={6}>
                    <Box component="h3" sx={{ color: 'secondary.main' }}>{purchaseOrder.displaynumber}</Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <LabelValuePair label="Created" value={textUtils.formatDateTime(purchaseOrder.dt_created)} />
                    <LabelValuePair label="Subtotal" value={textUtils.formatMoney(purchaseOrder.subtotal)} />
                    <LabelValuePair label="VAT" value={textUtils.formatMoney(purchaseOrder.vat)} />
                    <LabelValuePair label="Total" value={textUtils.formatMoney(purchaseOrder.total)} />
                    {purchaseOrder.summary && (
                        <LabelValuePair label="Summary" value={textUtils.stripTags(purchaseOrder.summary)} />
                    )}
                </Grid>
            </Grid>
        </PurchaseOrderCardPaper>
    );
}

export default PurchaseOrderCard;
